import documentsMap from './documents-map.json'

function generateAcronym(text) {
  if (!text || typeof text !== 'string') return ''

  const words = text.trim().split(/\s+/)
  if (words.length <= 1) return ''

  return words.map((word) => word.charAt(0).toUpperCase()).join('')
}

function generateKeywords(item, docData) {
  const keywords = []

  if (docData.keywords && Array.isArray(docData.keywords)) {
    keywords.push(...docData.keywords)
  }

  if (item.labelEn) {
    keywords.push(item.labelEn)
    const acronym = generateAcronym(item.labelEn)
    if (acronym) {
      keywords.push(acronym)
    }
  }

  return [...new Set(keywords.filter((k) => k && k.trim() !== ''))]
}

export function transferMenu2Document(menu) {
  const result = []

  function flattenMenu(items, parentBreadcrumbs = []) {
    if (!Array.isArray(items)) return

    items.forEach((item) => {
      const currentBreadcrumbs = [...parentBreadcrumbs, item.label]

      if (item.url) {
        const menuItem = {
          id: item.id,
          label: item.label,
          labelEn: item.labelEn,
          url: item.url,
          target: item.target,
          breadcrumbs: currentBreadcrumbs
        }

        const docData = documentsMap[item.id] || {}
        menuItem.keywords = generateKeywords(item, docData)
        menuItem.contents = docData.contents || []

        result.push(menuItem)
      }

      if (item.items && Array.isArray(item.items)) {
        flattenMenu(item.items, currentBreadcrumbs)
      }
    })
  }

  flattenMenu(menu)

  return result
}
